import React, { Component } from 'react';
import { Form } from 'informed';
import axios from 'axios';
import { API_HOST } from '../../consts';
import InputSelect from '../../components/inputs/InputSelect';
import { toast } from 'react-toastify';
import { Nav, NavItem, NavLink, Modal, ModalBody } from 'reactstrap';
import classnames from 'classnames';
import { withTheme } from 'styled-components';
import { get } from 'lodash';
import { Link } from 'react-router-dom';
class GPTFormIndPlan extends Component {
  state = {
    loading: false
  };
  handleFilterChange = (filters) => {
    this.props.onFilterChange(filters);
  };

  state = {
    etapaOption: [],
    areaConhecimentoOption: [],
    componenteCurricularOption: [],
    habilidadeOption: [],
    periodoOptions: [],
    momentosOptions: [],
    typesofgenerators: 4,
    selectedAreaConhecimento: null,
    selectedPeriodo: null,
    isLoading: false,
    ano: null,
    prova: null,
    diretorioRegional: null,
    municipios: null,
    escola: null,
    serieEtapa: null,
    turma: null,
    periodo_id: null,
    ano_id: null,
    periodo_ano_id: null,
    prova_id: null,
    dr_id: null,
    diretorio_id: null,
    municipios_id: null,
    escola_id: null,
    serie_id: null,
    turma_id: null,
    area_id: null,
    selectTurma: null,
    estudantes: null,
    apiInfo: {},
    typesofgeneratorsMap: []
  };

  convertMinutesToHour(value) {
    var hour = Math.floor(value / 60);
    var minutes = value % 60;

    var hourString = hour.toString().padStart(2, '0');
    var minutosString = minutes.toString().padStart(2, '0');

    return hourString + 'hrs e ' + minutosString + 'minutos';
  }

  componentDidMount() {
    this.fetchApiResponse();
    this.fetchtypesofgenerators();
  }

  fetchDre = () => {
    axios
      .get(`${API_HOST}/avalia/dre`)
      .then((res) => {
        const data = res.data;
        data.map((dre) => {
          dre.label = dre.dre_name;
          dre.value = dre.id;
        });
        this.setState({ dreOptions: data });
      })
      .catch((err) => {
        toast.error(err);
      });
  };

  fetchMunicipios = (id) => {
    axios
      .get(`${API_HOST}/avalia/municipio?dre_id=${id}`)
      .then((res) => {
        const data = res.data.results;
        data.map((dre) => {
          dre.label = dre.nm_municipio;
          dre.value = dre.cd_municipio;
        });
        this.setState({ municipios: data });
      })
      .catch((err) => {
        toast.error(err);
      });
  };

  fetchEscola = (id) => {
    axios
      .get(`${API_HOST}/avalia/escola?cd_municipio=${id}`)
      .then((res) => {
        const data = res.data;
        data.map((escola) => {
          escola.label = escola.nm_escola;
          escola.value = escola.cd_escola;
        });
        this.setState({ escola: data });
      })
      .catch((err) => {
        toast.error(err);
      });
  };

  fetchSerie = (id) => {
    axios
      .get(`${API_HOST}/avalia/escola_etapa?cd_escola=${id}`)
      .then((res) => {
        const data = res.data.results;
        data.map((serie) => {
          serie.label = serie.dc_etapa;
          serie.value = serie.dc_etapa;
        });
        this.setState({ serieEtapa: data });
      })
      .catch((err) => {
        toast.error(err);
      });
  };

  fetchEstudantes = () => {
    if (this.state.selectTurma && this.state.area_id) {
      axios
        .get(
          `${API_HOST}/avalia/estudante?cd_escola=${this.state.selectTurma['cd_escola']}&cd_turma=${this.state.selectTurma['cd_turma']}&nr_etapa=${this.state.selectTurma['nr_etapa']}&prova_a_cd_disciplina=${this.state.area_id}`
        )
        .then((res) => {
          const data = res.data.results;
          data.map((estudante) => {
            estudante.label = estudante.nm_aluno;
            estudante.value = estudante.id;
          });
          this.setState({ estudantes: data });
        })
        .catch((err) => {
          console.error(err);
          toast.error(err);
        });
    }
  };

  componentDidUpdate(prevPops, prevState) {
    if (
      prevState.selectTurma !== this.state.selectTurma ||
      prevState.area_id !== this.state.area_id
    ) {
      if (this.state.selectTurma && this.state.area_id) {
        axios
          .get(
            `${API_HOST}/avalia/estudante?cd_escola=${this.state.selectTurma['cd_escola']}&cd_turma=${this.state.selectTurma['cd_turma']}&nr_etapa=${this.state.selectTurma['nr_etapa']}&prova_a_cd_disciplina=${this.state.area_id}`
          )
          .then((res) => {
            const data = res.data.results;
            data.map((estudante) => {
              estudante.label = estudante.nm_aluno;
              estudante.value = estudante.id;
            });
            this.setState({ estudantes: data });
          })
          .catch((err) => {
            console.error(err);
            toast.error(err);
          });
      }
    }
  }

  fetchTurma = (id, escola) => {
    axios
      .get(
        `${API_HOST}/avalia/periodo_ano?periodo__id=${this.state.periodo_id}&ano__id=${this.state.ano_id}`
      )
      .then((res) => {
        const data = res.data;
        axios
          .get(
            `${API_HOST}/avalia/turma?cd_escola=${escola}&cd_etapa=${id}&periodo_ano_id=${data[0].id}`
          )
          .then((res) => {
            const data = res.data.results;
            data.map((serie) => {
              serie.label = serie.nm_turma;
              serie.value = serie.cd_turma;
            });
            this.setState({ turma: data });
          })
          .catch((err) => {
            toast.error(err);
          });
      })
      .catch((err) => {
        toast.error(err);
      });
  };

  fetchAno = () => {
    axios
      .get(`${API_HOST}/avalia/ano`)
      .then((res) => {
        const data = res.data;
        data.map((ano) => {
          ano.label = ano.ds_ano;
          ano.value = ano.id;
        });
        this.setState({ ano: data });
      })
      .catch((err) => {
        toast.error(err);
      });
  };

  fetchProva = () => {
    axios
      .get(`${API_HOST}/avalia/periodo`)
      .then((res) => {
        const data = res.data;
        data.map((periodo) => {
          periodo.label = periodo.ds_periodo;
          periodo.value = periodo.id;
        });
        this.setState({ prova: data });
      })
      .catch((err) => {
        toast.error(err);
      });
  };

  fetchMe() {
    const token = localStorage.getItem('token');
    axios
      .get(`${API_HOST}/login/me`, {
        headers: {
          Authorization: `JWT ${token}`
        }
      })
      .then((response) => {
        this.setState({ me: response.data });
      })
      .catch((response) => toast.error(response.error));
  }

  fetchEtapaEscola = () => {
    axios
      .get(`${API_HOST}/core/curso`, {})
      .then((response) => {
        const options = [];
        response.data.forEach((mapResponse) => {
          if (mapResponse.oculto !== true) {
            options.push({
              value: mapResponse.id,
              label: mapResponse.descricao,
              codigo: mapResponse.codigo
            });
          }
        });

        this.setState({ etapaOption: options });
        // setOptionsInput((prevState) => ({ ...prevState, curso: options }));
      })
      .catch((error) => console.error(error));
  };

  fetchNivel = () => {
    axios.get(`${API_HOST}/core/periodo`).then((response) => {
      const options = [];

      response.data.map((mapResponse) => {
        if (mapResponse.etapa_nr) {
          options.push({
            value: mapResponse.id,
            label: mapResponse.descricao,
            codigo: mapResponse.etapa_nr
          });
        }
      });
      this.setState({ periodoOptions: options });
    });
  };

  fetchAreasConhecimento() {
    axios.get(`${API_HOST}/avalia/disciplina`).then((response) => {
      const options = response.data.results.map((item) => ({
        value: item.id,
        label: item.disciplina
      }));
      this.setState({ areaConhecimentoOption: options });
    });
  }

  fetchPalavrasChave(input, callback) {
    axios
      .get(`${API_HOST}/itens/palavra_chave`, {
        params: {
          search: input
        }
      })
      .then((response) => {
        callback(null, {
          options: response.data.results.map((x) => ({
            value: String(x.id),
            label: x.descricao
          }))
        });
      });
  }

  fetchMomentos() {
    axios
      .get(`${API_HOST}/openai/moments`)
      .then((response) => {
        const options = response.data.map((mapResponse) => ({
          value: mapResponse.id,
          label: mapResponse.descricao,
          codigo: mapResponse.codigo
        }));

        this.setState({ momentosOptions: options });
      })
      .catch((err) => {
        console.error(err);
      });
  }

  fetchtypesofgenerators() {
    axios.get(`${API_HOST}/openai/typesofgenerators`).then((response) => {
      this.setState({ typesofgeneratorsMap: response.data });
    });
  }

  percentageToNumber(percentageString) {
    const cleanedString = percentageString.replace('%', '');
    const numberValue = parseFloat(cleanedString);
    const decimalValue = numberValue / 100;
    return decimalValue;
  }

  fetchStudentInfo(idn) {
    axios
      .get(`${API_HOST}/avalia/estudante_desempenho?idn=${idn}`)
      .then((response) => {
        response.data.results.map(
          (info) => (info.perc = this.percentageToNumber(info.porc_acertos))
        );
        const nResp = response.data.results.filter((info) => info.perc <= 0.6);
        const nInfo = [];
        nResp.map((info) =>
          nInfo.push({
            cd_habilidade: info.cd_habilidade,
            habilidade: info.habilidade
          })
        );
        this.setState({
          apiInfo: { ...this.state.apiInfo, studentScore: nInfo }
        });
      })
      .catch((error) => console.error(error));
  }

  convertInitials(name) {
    const words = name.trim().split(/\s+/);
    const formattedWords = words.map((word) => {
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    });
    return formattedWords.join(' ');
  }

  componentDidMount() {
    this.fetchMe();
    this.fetchEtapaEscola();
    this.fetchAreasConhecimento();
    this.fetchNivel();
    this.fetchMomentos();
    this.fetchAno();
    this.fetchDre();
  }

  formApiData = () => {
    const { history } = this.props;
    const values = this.state.apiInfo;
    const { typesofgenerators } = this.state;
    const paramsValues = {
      ...values
    };

    if (!values.estudante) {
      toast.error(
        'O campo Estudante do formulário deve ser preenchido, para prosseguir com a ação.'
      );
      return;
    }
    let payload = [];

    payload.push(
      { type: typesofgenerators },
      {
        form: {
          values: paramsValues
        }
      }
    );
    this.setState({ isLoading: true });
    axios
      .post(`${API_HOST}/openai/api-response/request_inter_api`, {
        payload
      })
      .then((response) => {
        history.replace(
          `/assistente-pessoal-retorno-v0/${response.data.api_response_id}`
        );
      })
      .catch((error) => {
        this.setState({ isLoading: false });
        console.error(error);
        toast.error('Ocorreu um erro, Tente novamente.');
      });
  };

  render() {
    const {
      isLoading,
      areaConhecimentoOption,
      ano,
      prova,
      dreOptions,
      municipios,
      escola,
      serieEtapa,
      turma,
      estudantes,
      apiInfo,
      typesofgeneratorsMap
    } = this.state;

    const showTab = true;
    if (showTab) {
      return (
        <>
          <div style={{ marginTop: '24px' }}>
            <div className="container mb-4 pb-4">
              <div className="row">
                <div className="col-12">
                  <div
                    className="card"
                    style={{ backgroundColor: '#f7f7f7', borderRadius: '10px' }}
                  >
                    <Nav
                      style={{
                        fontSize: '19px',
                        fontWeight: 600,
                        color: '#607173',
                        borderRadius: '10px 10px 0px 0px',
                        background: '#fff'
                      }}
                      tabs
                    >
                      {typesofgeneratorsMap.filter(
                        (values) => values.codigo === '5'
                      )[0] ? (
                        typesofgeneratorsMap.filter(
                          (values) => values.codigo === '5'
                        )[0].enabled ? (
                          <NavItem>
                            <Link to="/assistente-pessoal-form/inter">
                              <NavLink
                                className={classnames({
                                  active_tab: false
                                })}
                              >
                                Plano de intervenção
                              </NavLink>
                            </Link>
                          </NavItem>
                        ) : (
                          ''
                        )
                      ) : (
                        ''
                      )}

                      {typesofgeneratorsMap.filter(
                        (values) => values.codigo === '1'
                      )[0] ? (
                        typesofgeneratorsMap.filter(
                          (values) => values.codigo === '1'
                        )[0].enabled ? (
                          <NavItem>
                            <Link to="/assistente-pessoal-form/plan">
                              <NavLink
                                className={classnames({
                                  active_tab: false
                                })}
                              >
                                Sugestão Pedagógica
                              </NavLink>
                            </Link>
                          </NavItem>
                        ) : (
                          ''
                        )
                      ) : (
                        ''
                      )}

                      {typesofgeneratorsMap.filter(
                        (values) => values.codigo === '2'
                      )[0] ? (
                        typesofgeneratorsMap.filter(
                          (values) => values.codigo === '2'
                        )[0].enabled ? (
                          <NavItem>
                            <Link to="/assistente-pessoal-form/ind">
                              <NavLink
                                className={classnames({
                                  active: this.state.activeTab === 'dados'
                                })}
                              >
                                Atividade Individual
                              </NavLink>
                            </Link>
                          </NavItem>
                        ) : (
                          ''
                        )
                      ) : (
                        ''
                      )}

                      {typesofgeneratorsMap.filter(
                        (values) => values.codigo === '3'
                      )[0] ? (
                        typesofgeneratorsMap.filter(
                          (values) => values.codigo === '3'
                        )[0].enabled ? (
                          <NavItem>
                            <Link to="/assistente-pessoal-form/group">
                              <NavLink
                                className={classnames({
                                  active:
                                    this.state.activeTab ===
                                    'matrizes_referencia'
                                })}
                              >
                                Atividades em Grupo
                              </NavLink>
                            </Link>
                          </NavItem>
                        ) : (
                          ''
                        )
                      ) : (
                        ''
                      )}

                      {typesofgeneratorsMap.filter(
                        (values) => values.codigo === '4'
                      )[0] ? (
                        typesofgeneratorsMap.filter(
                          (values) => values.codigo === '4'
                        )[0].enabled ? (
                          <NavItem>
                            <NavLink
                              className={classnames({
                                active: true
                              })}
                            >
                              Plano Individual
                            </NavLink>
                          </NavItem>
                        ) : (
                          ''
                        )
                      ) : (
                        ''
                      )}
                    </Nav>
                    <div className="card-body">
                      <div style={{ textAlign: 'center', padding: '1.5rem' }}>
                        <span
                          style={{
                            fontSize: '22px',
                            fontWeight: 'bold'
                          }}
                        >
                          Preencha os dados abaixo para que o sistema gere o seu
                          Plano Individual
                        </span>
                      </div>
                      <Form
                        getApi={(formApi) => {
                          this.formApi = formApi;
                        }}
                      >
                        {({ formState }) => <div className="row"></div>}
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center'
                          }}
                        >
                          <div className="input-type-style row">
                            <div className="col-md-6">
                              <label
                                style={{ marginBottom: '-1rem' }}
                                htmlFor="Ano"
                                className="input-label-style"
                              >
                                <span className="filter-label">Ano </span>
                              </label>
                              <InputSelect
                                label=""
                                field="ano"
                                options={ano}
                                onChange={(e) => {
                                  this.fetchProva();
                                  this.setState({ ano_id: e.id });
                                }}
                              />
                            </div>
                            <div className="col-md-6">
                              <label
                                htmlFor="Prova"
                                className="input-label-style"
                                style={{ marginBottom: '-1rem' }}
                              >
                                <span className="filter-label">Prova</span>
                              </label>
                              <InputSelect
                                // key={prova.id}
                                label=""
                                field="prova"
                                options={prova}
                                onChange={(e) => {
                                  this.setState({ periodo_id: e.id });
                                }}
                              />
                            </div>
                          </div>
                          <div className="input-type-style row">
                            <div className="col-md-6">
                              <label
                                htmlFor="diretorio regional"
                                className="input-label-style"
                                style={{ marginBottom: '-1rem' }}
                              >
                                <span className="filter-label">
                                  Diretório regional (DR)
                                </span>
                              </label>
                              <InputSelect
                                autoload
                                label=""
                                col="col-md-12"
                                field="municipios"
                                options={dreOptions}
                                onChange={(e) => {
                                  this.fetchMunicipios(e ? e.value : null);
                                  this.setState({ diretorio_id: e.value });
                                }}
                              />
                            </div>
                            <div className="col-md-6">
                              <label
                                htmlFor="Municipios"
                                className="input-label-style"
                                style={{ marginBottom: '-1rem' }}
                              >
                                <span className="filter-label">Municipios</span>
                              </label>
                              <InputSelect
                                autoload
                                label=""
                                col="col-md-12"
                                field="Municipios"
                                options={municipios}
                                onChange={(e) => {
                                  this.fetchEscola(e ? e.value : null);
                                  this.setState({ municipios_id: e.value });
                                }}
                              />
                            </div>
                          </div>
                          <div className="input-type-style row">
                            <div className="col-md-6">
                              <label
                                htmlFor="Escolas"
                                className="input-label-style"
                                style={{ marginBottom: '-1rem' }}
                              >
                                <span className="filter-label">Escolas</span>
                              </label>
                              <InputSelect
                                autoload
                                label=""
                                col="col-md-12"
                                field="Escolas"
                                options={escola}
                                onChange={(e) => {
                                  this.fetchSerie(e ? e.value : null);
                                  this.setState({ escola_id: e.cd_escola });
                                }}
                              />
                            </div>
                            <div className="col-md-6">
                              <label
                                htmlFor="Série/Ano"
                                className="input-label-style"
                                style={{ marginBottom: '-1rem' }}
                              >
                                <span className="filter-label">Série/Ano</span>
                              </label>
                              <InputSelect
                                label=""
                                field="serie"
                                options={serieEtapa}
                                onChange={(e) => {
                                  this.fetchTurma(
                                    e.cd_etapa,
                                    serieEtapa.filter(
                                      (serie) => serie.value === e.value
                                    )[0].cd_escola
                                  );
                                  this.setState({
                                    apiInfo: { ...apiInfo },
                                    serie_id: e.cd_etapa
                                  });
                                }}
                              />
                            </div>
                          </div>
                          <div className="input-type-style row">
                            <div className="col-md-6">
                              <label
                                htmlFor="Turma"
                                className="input-label-style"
                                style={{ marginBottom: '-1rem' }}
                              >
                                <span className="filter-label">Turma</span>
                              </label>
                              <InputSelect
                                label=""
                                col="col-md-12"
                                field="Turma"
                                options={turma}
                                onChange={(e) => {
                                  this.setState({
                                    apiInfo: {
                                      ...apiInfo,
                                      municipio: this.convertInitials(
                                        e.nm_municipio
                                      ),
                                      escola: e.nm_escola,
                                      serieEtap: e.dc_etapa
                                    },
                                    selectTurma: e,
                                    turma_id: e.value
                                  });
                                }}
                              />
                            </div>
                            <div className="col-md-6">
                              <label
                                style={{ marginBottom: '-1rem' }}
                                htmlFor="Área do conhecimento"
                                className="input-label-style"
                              >
                                <span className="filter-label">
                                  Área do conhecimento{' '}
                                </span>
                              </label>
                              <InputSelect
                                label=""
                                field="area_conhecimento"
                                onChange={(e) => {
                                  this.setState({ area_id: e.value });
                                }}
                                options={areaConhecimentoOption}
                              />
                            </div>
                          </div>
                          <div className="input-type-style row">
                            <div className="col-md-12">
                              <label
                                style={{ marginBottom: '-1rem' }}
                                htmlFor="Estudante"
                                className="input-label-style"
                              >
                                <span className="filter-label">Estudante</span>
                              </label>
                              {/* <InputText
                                stlye={{ marginTop: '2.5rem' }}
                                label=""
                                field="estudante"
                                onClick={this.fetchEstudantes}
                              /> */}
                              <InputSelect
                                label=""
                                field="estudante"
                                options={estudantes}
                                onChange={(e) => {
                                  this.setState({
                                    apiInfo: {
                                      ...apiInfo,
                                      estudante: this.convertInitials(
                                        e.nm_aluno
                                      )
                                    }
                                  });
                                  this.fetchStudentInfo(e.idn);
                                }}
                              />
                            </div>
                          </div>
                          <div
                            className="input-type-style"
                            style={{
                              display: 'flex',
                              justifyContent: 'center'
                            }}
                          >
                            <button
                              style={{
                                color: 'white',
                                backgroundColor: this.props.theme.primary,
                                border: 'none',
                                fontSize: '1rem',
                                fontWeight: '600',
                                textAlign: 'center',
                                cursor: 'pointer',
                                borderRadius: '15px',
                                boxShadow: '2px 4px 5px rgba(58, 58, 58, 0.25)',
                                letterSpacing: '1px',
                                padding: '4px 16px',
                                display: 'flex',
                                justifyContent: 'center',
                                flexDirection: 'row',
                                alignItems: 'center'
                              }}
                              onClick={() => this.formApiData()}
                              disabled={isLoading}
                            >
                              + Gerar Sugestão Pedagógica
                            </button>
                            <Modal
                              style={{ marginTop: '500px' }}
                              size="lg"
                              isOpen={isLoading}
                              toggle={this.toggle}
                            >
                              <ModalBody style={{ padding: '1.5rem' }}>
                                <div style={{ textAlign: 'center' }}>
                                  <img
                                    src={get(this.props.theme, 'loadingGif')}
                                    style={{ width: '42px' }}
                                    alt=""
                                  />
                                  <p style={{ color: '#000' }}>
                                    Gerando (Tempo médio de 3 minutos), por
                                    favor aguarde um momento
                                  </p>
                                  <p style={{ color: '#f00' }}>
                                    Mantenha está aba do navegador aberta
                                    durante todo o processo.
                                  </p>
                                </div>
                              </ModalBody>
                            </Modal>
                          </div>
                        </div>
                      </Form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      );
    }
  }
}

export default withTheme(GPTFormIndPlan);
